import Box from 'ui/src/components/Box'
import LogoCircle from 'ui/src/assets/images/ProtexxaLogos/ProtexxaLogo-circle.svg?react'

const Header = () => {
  return (
    <Box
      sx={{
        pl: { xs: 2, md: 12 },
        py: 3,
      }}
    >
      <LogoCircle />
    </Box>
  )
}

export default Header
